import src from "IMAGE";
export default { src, width: 486, height: 53, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mNok1ZqaJdWagTihgJxmcx+WZXOeQoa0+cCcY2kfDEAqAEKUuwhVkMAAAAASUVORK5CYII="};
